// gkc_hash_code : 01EV64EDXCZTX8ZCEMHJHDQ126
export const magazines = {
  button: {
    detail: '詳しく見る',
  },
};
